import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, BarChart3, CheckCircle, TrendingUp } from "lucide-react";
export default function UnlockYourBusinessPotentialWithStreamlinedOperations() {
  const benefits = [{
    id: 1,
    icon: BarChart3,
    title: "Comprehensive Workflow Review",
    description: "We analyze your existing processes from end to end, identifying inefficiencies and redundancies."
  }, {
    id: 2,
    icon: CheckCircle,
    title: "Bottleneck Identification",
    description: "Pinpoint critical obstacles that slow down operations and hinder productivity."
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Actionable Improvements",
    description: "Receive a clear roadmap with prioritized recommendations to optimize your systems."
  }];
  return <section className="relative bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="mx-auto max-w-3xl text-center mb-16 animate-fade-in-up">
          <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            Unlock Your Business Potential with Streamlined Operations
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Aran Group's Operational Efficiency Audits service helps you review and enhance workflows, 
            identify bottlenecks, and implement improvements that drive measurable results.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <div key={benefit.id} data-index={i} className="card bg-background border border-border rounded-lg p-8 hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <div className="flex items-center justify-center w-14 h-14 bg-primary/10 rounded-lg mb-6">
                  <IconComponent className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="text-center">
          <div className="inline-flex flex-col sm:flex-row gap-4">
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary">
                Schedule Your Audit
                <ArrowRight className="ml-2" />
              </Button>
            </Link>
            <Link to="/HomePage">
              <Button variant="outline" size="lg">
                Learn More About Our Services
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}